<footer class="main-footer">
  <a mat-raised-button color="accent" href="https://themeforest.net/item/tgss-angular-4-material-design-admin-template/20161805">Buy tgss</a>
  <span class="m-auto"></span>
  Design & Developed by <a href="https://ui-lib.com"> UI Lib</a>
</footer>